import React from 'react';
import {Skeleton} from "@mui/material";
import {ReportSummaryMapping} from "./ReportSummaryWithLoader";
import {
  GroupSummariesCardContainer,
  GroupSummariesCardItemBackground,
  GroupSummariesCardItemContainer
} from "@securspace/securspace-ui-kit";
import {
  GroupSummariesCardFullScreen
} from "../../cardComponents";

interface ReportSummaryLoaderProps {
  mapping: ReportSummaryMapping[];
}

const ReportSummaryLoader = ({
  mapping
}: ReportSummaryLoaderProps) => {
  return <GroupSummariesCardFullScreen>
      <GroupSummariesCardContainer>
        {
          Array.from({ length: mapping.length }).map((_, index) => (
            <GroupSummariesCardItemContainer key={index}>
              <GroupSummariesCardItemBackground>
                <Skeleton variant="text" width="100%" height={30} />
                <Skeleton variant="text" width="80%" height={30} />
              </GroupSummariesCardItemBackground>
            </GroupSummariesCardItemContainer>
          ))
        }
      </GroupSummariesCardContainer>
  </GroupSummariesCardFullScreen>
}

export { ReportSummaryLoader };
